import type {RouteLocationNormalizedGeneric} from 'vue-router';
import useAcl from '@/composables/useAcl';

export const permissionGuard = (to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  const {hasPermissions} = useAcl();

  if (!to?.meta?.permissions) {
    return true;
  }

  const hasPermission = hasPermissions(to.meta.permissions);

  if (hasPermission) {
    return true;
  }

  return {name: 'dashboard'};
};
